import { ClientIntakeFormContextState } from './clientIntakeFormContext.firebase.state';

export class ClientIntakeFormContextSelectors {
	static readonly _props = ClientIntakeFormContextState._props;

	static readonly $getAllClientIntakeFormContext =
		ClientIntakeFormContextState._props.items;
}
